import type { Component } from 'vue'
import { PhCloud, PhDatabase, PhDeviceMobile, PhGlobe, PhLightning, PhMonitor } from '@phosphor-icons/vue'
import { markRaw } from 'vue'

export interface Service {
  id: string
  title: string
  slug: string
  icon: Component
  description: string
  technologies: string[]
}

export const services: Service[] = [
  {
    id: '1',
    title: 'Web Development',
    slug: 'web-development',
    icon: markRaw(PhGlobe),
    description: 'Complete web application development from concept to deployment, including both frontend and backend components.',
    technologies: [
      'HTML5',
      'CSS3',
      'JavaScript',
      'PHP',
      'Laravel',
      'Vue',
      'Nuxt.js',
      'Node.js',
      'MySQL',
      'PostgreSQL',
      'Git',
      'Docker',
      'Apache',
      'NGINX',
      'Linux',
      'Ubuntu Linux',
      'Windows',
      'MacOS',
      'GitHub',
      'Bitbucket',
      'REST APIs',
      'JSON',
      'XML',
      'OAuth 2',
      'Stripe API',
      'PayPal API',
      'AWS',
      'Amazon EC2',
      'Amazon S3',
    ],
  },
  {
    id: '2',
    title: 'Frontend Development',
    slug: 'frontend-development',
    icon: markRaw(PhMonitor),
    description: 'Modern, responsive user interfaces built with cutting-edge frontend technologies and frameworks.',
    technologies: [
      'Vue',
      'Nuxt.js',
      'React',
      'Svelte',
      'JavaScript',
      'TypeScript',
      'HTML5',
      'CSS3',
      'Tailwind CSS',
      'Bootstrap',
      'Sass',
      'jQuery',
      'Vuex',
      'Pinia',
      'Redux',
      'Webpack',
      'Vite',
      'NPM',
      'Ajax',
      'PSD to HTML',
      'Pixel Perfect',
      'Responsive Design',
      'PWA',
      'WebSockets',
      'Socket.IO',
    ],
  },
  {
    id: '3',
    title: 'Backend Development',
    slug: 'backend-development',
    icon: markRaw(PhDatabase),
    description: 'Robust server-side applications, APIs, and database solutions built for scalability and performance.',
    technologies: [
      'PHP',
      'Laravel',
      'Node.js',
      'Express.js',
      'Python',
      'Ruby on Rails',
      'MySQL',
      'PostgreSQL',
      'MongoDB',
      'Redis',
      'Memcached',
      'REST APIs',
      'GraphQL',
      'OAuth 2',
      'JWT',
      'Docker',
      'Linux',
      'Ubuntu Linux',
      'Apache',
      'NGINX',
      'PHP-FPM',
      'Composer',
      'NPM',
      'Git',
      'CI/CD Pipelines',
    ],
  },
  {
    id: '4',
    title: 'API Development',
    slug: 'api-development',
    icon: markRaw(PhLightning),
    description: 'Custom API development and integration services for seamless data exchange and third-party connectivity.',
    technologies: [
      'REST APIs',
      'GraphQL',
      'JSON',
      'XML',
      'OAuth 2',
      'JWT',
      'Laravel',
      'Node.js',
      'Express.js',
      'PHP',
      'Python',
      'MySQL',
      'PostgreSQL',
      'MongoDB',
      'Redis',
      'Docker',
      'Postman',
      'Swagger',
      'Stripe API',
      'PayPal API',
      'Google API',
      'Webhooks',
      'Rate Limiting',
      'API Documentation',
    ],
  },
  {
    id: '6',
    title: 'Mobile App Development',
    slug: 'mobile-app-development',
    icon: markRaw(PhDeviceMobile),
    description: 'Cross-platform and native iOS and Android apps built with React Native, from prototype to App Store and Google Play release.',
    technologies: [
      'React Native',
      'Expo',
      'iOS',
      'Android',
      'Swift',
      'Kotlin',
      'TypeScript',
      'Redux',
      'Firebase',
      'Push Notifications',
      'REST APIs',
      'GraphQL',
      'In-App Purchases',
      'Fastlane',
      'TestFlight',
      'App Store Connect',
      'Google Play Console',
      'CI/CD Pipelines',
    ],
  },
  {
    id: '5',
    title: 'DevOps & Deployment',
    slug: 'devops-deployment',
    icon: markRaw(PhCloud),
    description: 'Infrastructure setup, deployment automation, and continuous integration for reliable application delivery.',
    technologies: [
      'Docker',
      'Docker Compose',
      'Docker Swarm',
      'AWS',
      'Amazon EC2',
      'Amazon S3',
      'Amazon RDS',
      'AWS Lambda',
      'Linux',
      'Ubuntu Linux',
      'RHEL/CentOS',
      'Apache',
      'NGINX',
      'Git',
      'GitHub',
      'Bitbucket',
      'CI/CD Pipelines',
      'Travis CI',
      'Jenkins',
      'Vagrant',
      'SSH',
      'Cron',
      'Load Balancers',
    ],
  },
]
